import { Store, StoreType } from '@extTypes/api/customily/user';

export const getStoreType = (shop: string, stores: Store[]) => stores.find((s) => s.Url === shop)?.Type;

/**
 * First store the user can actually work with. Picking stores[0] blindly can select a disabled or
 *  uninstalled store, which the server rejects with "No shop <url> for this user".
 */
export const firstAvailableStore = (stores: Store[]) => stores.find((s) => !s.Disabled && s.AppInstalled);

export const isStoreOfType = (shop: string, stores: Store[], storeType: StoreType) => {
    return stores.some((s) => s.Url === shop && s.Type === storeType);
};

export const isStoreOfTypes = (shop: string, stores: Store[], storeType: StoreType[]) => {
    return stores.some((s) => s.Url === shop && storeType.includes(s.Type));
};

/** Platforms without a theme to inject into: Customily hosts the personalization page itself. */
export const STANDALONE_STORE_TYPES: StoreType[] = [
    StoreType.Etsy,
    StoreType.Custom,
    StoreType.Amazon,
    StoreType.TikTok
];

/** Standalone platforms whose personalization is tied to an order placed in the marketplace. */
export const ORDER_STANDALONE_STORE_TYPES: StoreType[] = [StoreType.Etsy, StoreType.Amazon, StoreType.TikTok];

export const isStandaloneStoreType = (storeType?: StoreType) =>
    storeType !== undefined && STANDALONE_STORE_TYPES.includes(storeType);

export const isStandaloneStore = (shop: string, stores: Store[]) =>
    isStoreOfTypes(shop, stores, STANDALONE_STORE_TYPES);

export const isOrderStandaloneStore = (shop: string, stores: Store[]) => {
    return isStoreOfTypes(shop, stores, ORDER_STANDALONE_STORE_TYPES);
};

export const isWooCommerceStore = (shop: string, stores: Store[]) => {
    const store = stores.find((s) => {
        return s.Url === shop;
    });
    return store && store.Type === StoreType.WooCommerce;
};

export const hasWooCommerceStores = (stores: Store[]) => {
    return stores.some((s) => s.Type === StoreType.WooCommerce);
};

export const isEtsyStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Etsy);
};

export const isTikTokStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.TikTok);
};

export const isCustomStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Custom);
};

export const isShoplazzaStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Shoplazza);
};

export const isAmazonStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Amazon);
};

export const isShopify = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Shopify);
};
